import React from 'react';

export default ({ color = '#B5BCCB', size = 19 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 5.54199V9.50033L12.6667 12.667"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.77344 2.77148V5.93815H5.9401"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.98047 9.50033C1.98047 13.654 5.34766 17.0212 9.5013 17.0212C13.6549 17.0212 17.0221 13.654 17.0221 9.50033C17.0221 5.34668 13.6549 1.97949 9.5013 1.97949C6.63659 1.97949 4.14598 3.58114 2.87609 5.93783L2.95893 5.7882"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
